import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  session: null
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserSession: (state, action) => {
      state.session = action.payload ?? null;
    },
    clearUserSession: (state) => {
      state.session = null;
    }
  }
});

export const { setUserSession, clearUserSession } = userSlice.actions;

export default userSlice.reducer;
